import { Injectable } from '@angular/core';
import { EComService } from '@src/app/ecom-services/ecom-common.service';
import { BehaviorSubject } from 'rxjs'; 
// Declare the Facebook SDK types
declare const FB: any; 
@Injectable({
  providedIn: 'root'
})
export class FacebookAuthService {
  private fb: any; // Use non-null assertion operator

  private  readonly authStatusSubject = new BehaviorSubject<any>(null);

  authStatus = this.authStatusSubject.asObservable();

  constructor(public ecomservice: EComService) {
    this.loadFbSdk();
  }

  private loadFbSdk(): void {
    if (!document.getElementById('facebook-jssdk')) {
      // Ensure the script is not already added
      const js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      document.body.appendChild(js);
    }
    (window as any).fbAsyncInit = () => {
      this.fb = (window as any).FB;
      this.fb.init({
        appId: this.ecomservice.GetOlarConfigValue('FACEBOOK_APP_ID'),
        cookie: true,
        xfbml: true,
        version: 'v12.0'
      });

      this.fb.AppEvents.logPageView();
    };

    // Load Facebook SDK script dynamically
    (function (d: Document, s: string, id: string) {
      const js = d.createElement(s) as HTMLScriptElement; // Cast to HTMLScriptElement
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js"; // Now TypeScript knows `js` has `src`
      d.getElementsByTagName(s)[0].parentNode.insertBefore(js, null);
    })(document, 'script', 'facebook-jssdk');
  }

  login()  { 

    if (this.fb) {
      this.fb.getLoginStatus((response: any) => {
        if (response.status === 'connected') {
          this.authStatusSubject.next(response);
        } else {
          this.fb.login((response: any) => {
            if (response.status === 'connected') {
              this.authStatusSubject.next(response);
            }
          }, { scope: 'public_profile,email' });
        }
      });
    }
  }

  logout(): void { 
    if (this.fb) {
      this.fb.logout((response: any) => {
        this.authStatusSubject.next(null);
      });
    }
  }

  async getUserProfile(): Promise<any> {  
    return new Promise((resolve, reject) => {
      if (this.fb) {
        this.fb.api('/me?fields=id,name,email,first_name,last_name,name_format,gender,birthday,picture', (response: any) => {
          if (!response || response.error) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      } else {
        reject('Facebook SDK not initialized');
      }
    });
  }
}
